import apiClient from './api'
import type {
  ApiResponse,
  AuthTokens,
  OtpResult,
  ResetToken,
  User,
  LoginRequest,
  RegisterRequest,
  VerifyOtpRequest,
  SetupPasswordRequest,
  RefreshTokenRequest,
  ForgotPasswordRequest,
  VerifyResetOtpRequest,
  ResetPasswordRequest,
  LogoutRequest,
} from '@/types'

// 1:1 with Schema_Specification Section 4.1 (auth). Every fn returns the seed envelope.
export const authApi = {
  me: () =>
    apiClient.get<ApiResponse<User>>('/auth/me').then(r => r.data),

  login: (body: LoginRequest) =>
    apiClient
      .post<ApiResponse<AuthTokens>>('/auth/login', body)
      .then(r => r.data),

  register: (body: RegisterRequest) =>
    apiClient
      .post<ApiResponse<OtpResult>>('/auth/register', body)
      .then(r => r.data),

  verifyRegisterOtp: (body: VerifyOtpRequest) =>
    apiClient
      .post<ApiResponse<AuthTokens>>('/auth/verify-register-otp', body)
      .then(r => r.data),

  setupPassword: (body: SetupPasswordRequest) =>
    apiClient
      .post<ApiResponse<AuthTokens>>('/auth/setup-password', body)
      .then(r => r.data),

  refreshToken: (body: RefreshTokenRequest) =>
    apiClient
      .post<ApiResponse<AuthTokens>>('/auth/refresh-token', body)
      .then(r => r.data),

  forgotPassword: (body: ForgotPasswordRequest) =>
    apiClient
      .post<ApiResponse<null>>('/auth/forgot-password', body)
      .then(r => r.data),

  verifyResetOtp: (body: VerifyResetOtpRequest) =>
    apiClient
      .post<ApiResponse<ResetToken>>('/auth/verify-reset-otp', body)
      .then(r => r.data),

  resetPassword: (body: ResetPasswordRequest) =>
    apiClient
      .post<ApiResponse<null>>('/auth/reset-password', body)
      .then(r => r.data),

  logout: (body?: LogoutRequest) =>
    apiClient
      .post<ApiResponse<null>>('/auth/logout', body ?? {})
      .then(r => r.data),
}

export default authApi
